import React, {Component} from "react";
import {Button, Space} from "antd";
import {
    EditOutlined,
    PlusOutlined,
} from '@ant-design/icons';
import {DataTypes} from "../../data/types";
import {CompositionEditModal} from "./CompositionEditModal";
import {amIAdmin} from "../../helpers/auth";

const emptyComposition = {
    id: null,
    title: '',
    subtitle: '',
    categories: [],
    lyrics_author: '',
    composer: '',
    arranger: '',
    source_id: null,
    lyrics: '',
    description: ''
};

export class CompositionToolbar extends Component {

    state = {
        editModalTitle: '',
        editModalVisible: false,
        composition: emptyComposition
    };

    showAddModal = () => {
        this.setState({
            editModalVisible: true,
            editModalTitle: 'Nowy utwór',
            composition: emptyComposition
        });
    }

    showEditModal = () => {
        this.setState({
            editModalVisible: true,
            editModalTitle: this.props.compositions_entity.id + '. ' + this.props.compositions_entity.title,
            composition: this.props.compositions_entity
        });
    }

    onEditOk = (id, values) => {
        this.setState({editModalVisible: false}, () => {
            this.props.saveEntity(DataTypes.COMPOSITIONS, this.props[`${DataTypes.COMPOSITIONS}_params`], id, values, this.props.history);
        });
    }

    onEditCancel = () => {
        this.setState({editModalVisible: false});
    }

    render() {
        /*<Button type="primary"
                                icon={<EditOutlined/>}
                                onClick={this.showEditModal}>
                            Edytuj
                        </Button>
                        <Button type="primary"
                                icon={<PlusOutlined/>}
                                onClick={this.showAddModal}>
                            Dodaj
                        </Button>*/
        return <div style={{padding: '1em'}}>
                    <Space wrap={true}>
                        {amIAdmin() ?
                            <>
                                <Button type="primary"
                                        icon={<PlusOutlined/>}
                                        onClick={this.showAddModal}>
                                    Dodaj
                                </Button>
                                <Button type="primary"
                                        icon={<EditOutlined/>}
                                        onClick={this.showEditModal}
                                        disabled={!this.props.compositions_entity.id}
                                >
                                    Edytuj
                                </Button>
                            </> : null
                        }
                        <CompositionEditModal
                            visible={this.state.editModalVisible}
                            title={this.state.editModalTitle}
                            data={this.state.composition}
                            handleOk={this.onEditOk}
                            handleCancel={this.onEditCancel}
                            sources={this.props.sources}
                            categories={this.props.categories}
                            songbooks={this.props.songbooks}
                        />
                    </Space>
                </div>
    }
}
